// import iphone from "../../assets/iphone-side.png";
import right from "../../assets/right.svg";
// import aboutImage from "../../assets/screens/3.png";
import "./style.css";
import { useEffect, useState } from "react";
// import Iphone from "./Iphone";
import iphone from "../../assets/iphone.png";
import screen from "../../assets/screens/1.png";
import { useLocation } from "react-router-dom";

const About = () => {
	const location = useLocation();
	const [data, setData] = useState([
		{
			label: "Complete Organization",
			description:
				"All funeral details under one roof to make things easier for the family.",
		},
		{
			label: "Spiritual and Practical Services",
			description:
				"Distribution of Qur’ans, Zamzam water, and prayers, along with hospitality, chairs, and valet services.",
		},
		{
			label: "Family Comfort",
			description:
				"Ensuring a smooth and professional experience to ease the burden on the deceased’s family.",
		},
	]);

	useEffect(() => {
		if (location.state?.scrollTo) {
			const element = document.getElementById(location.state.scrollTo);
			if (element) {
				element.scrollIntoView({ behavior: "smooth" });
			}
		}
	}, [location]);

	return (
		<div
			className="about"
			id="about"
			data-aos="fade-up"
			data-aos-duration="1200">
			<div className="container">
				<p className="title">ABOUT YUSUR APP</p>
				<p className="description">
					Yusur is an app that enables the deceased’s family to organize funeral
					ceremonies easily and smoothly. The app offers a variety of services,
					including distributing Qur’ans and Zamzam water, prayers for the
					deceased, providing hospitality such as tea and coffee, valet parking,
					arranging necessary chairs, and printing the deceased’s name on
					prayers and water bottles. The app aims to simplify every detail of
					the funeral in an organized and professional manner.
				</p>
				<div className="about-data">
					<div className="row">
						<div className="col-md-6 mb-3 col-12 d-flex justify-content-center justify-center-mobile">
							<div className="phone-head">
								<div className="phone">
									<img src={iphone} className="iphone" alt="iphone" />
									<img src={screen} className="screen" alt="screen" />
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="about-description">
								{data?.map((res, index) => {
									return (
										<div key={index} className="about-description-card">
											<img src={right} alt="right" />
											<div>
												<p className="title">{res?.label}</p>
												<p className="description">{res?.description}</p>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default About;
